import {Injectable} from '@angular/core';

@Injectable()
export class Prestadores {
    prestador: any = [
        {
            nombre: 'ABAYAY BLAS FELIPE',
            domicilio: 'BALCARCE 739',
            telefono: '4422029',
            locacion: 'San Luis',
            especialidad: 'CLINICA MEDICA',             
          },
          {
            nombre: 'ABAYAY',
            domicilio: 'BALCARCE',
            telefono: '4422029',
            locacion: 'San Luis',
            especialidad: 'CLINICA MEDICA',             
          },
          {
            nombre: 'ABAYAY',
            domicilio: 'BALCARCE',
            telefono: '4422029',
            locacion: 'San Luis',
            especialidad: 'CLINICA MEDICA',             
          },
          {
            nombre: 'ABAYAY',
            domicilio: 'BALCARCE',
            telefono: '4422029',
            locacion: 'San Luis',
            especialidad: 'CLINICA MEDICA',             
          },
          {
            nombre: 'ABAYAY',
            domicilio: 'BALCARCE',
            telefono: '4422029',
            locacion: 'San Luis',
            especialidad: 'CLINICA MEDICA',             
          },
          {
            nombre: 'ABAYAY',
            domicilio: 'BALCARCE',
            telefono: '4422029',
            locacion: 'San Luis',
            especialidad: 'CLINICA MEDICA',             
          },
          {
            nombre: 'ABAYAY',
            domicilio: 'BALCARCE',
            telefono: '4422029',
            locacion: 'San Luis',
            especialidad: 'CLINICA MEDICA',             
          },
          {
            nombre: 'ABAYAY',
            domicilio: 'BALCARCE',
            telefono: '4422029',
            locacion: 'San Luis',
            especialidad: 'CLINICA MEDICA',             
          },

          			

    ]
    constructor() {
        
     }
    getPrestadores(){
      return this.prestador;
    }
   }